export default {
  // Page title
  title: "Registro de Notificaciones",

  // Search form
  searchForm: {
    pushTime: "Hora de Notificación",
    pushTimePlaceholder: "Seleccione rango de fechas",
    memberAccount: "Miembro a Notificar",
    memberAccountPlaceholder: "Ingrese",
    pushType: "Tipo de Notificación",
    pushTypePlaceholder: "Obtenga el tipo principal de notificación para este mensaje",
    memberType: "Tipo de Miembro",
    memberTypePlaceholder: "Seleccione",
    status: "Estado",
    statusPlaceholder: "Seleccione",
    search: "Consultar",
    reset: "Restablecer"
  },

  // Table column titles
  table: {
    memberAccount: "Miembro a Notificar",
    pushType: "Tipo de Notificación",
    memberType: "Tipo de Miembro",
    pushTitle: "Título de Notificación",
    pushContent: "Contenido de Notificación",
    pushTime: "Hora de Notificación",
    status: "Estado"
  },

  // Status
  status: {
    success: "Éxito",
    failed: "Fallido"
  },

  // Pagination
  pagination: {
    total: "Total {total} registros",
    pageInfo: "Página {currentPage}/{totalPages}",
    itemsPerPage: "elementos/página",
    jumpTo: "Ir a",
    page: "página"
  },

  // Messages
  messages: {
    fetchDataFailed: "Error al obtener datos",
    noData: "Sin datos",
    timeRangeExceeded: "El rango de fechas no puede exceder 1 mes, seleccione nuevamente."
  }
};
